import { helper } from "src/utils/helper";

class KargoKuryeTakipAramaKriterleri {
    baslangicTarih?: string = helper.datetimeToday();
    bitisTarih?: string = helper.datetimeToday();
    barkodNo?: number = null;
    organizasyonIds?: string = "";
    kuryeKurumIds?: string = "";
    iptal?: string = "H";
    onayli?: string = "H";
};
export default KargoKuryeTakipAramaKriterleri;

export class KargoKuryeTakipDetayAramaKriterleri {
    barkodNo?: number = null;
};